<div class="h-full flex flex-col justify-between">
    <div class="detail panel-content">
        <div class="header">
            <app-title
                class="header-title font-medium text-2xl"
                [title]="title()"
                (goToPreviousPage)="goToPreviousPage.emit()" />
        </div>
        @if (shouldDisplaySubtitle()) {
            <div class="pl-12">
                <p class="font-medium text-base pt-2">{{ subtitle() }}</p>
            </div>
        }
        <div class="content px-9">
            @if (businessIdentifier()) {
                <div class="panel-information flex flex-row justify-between flex-wrap gap-x-10 gap-y-3 my-8">
                    <div class="flex flex-col">
                        <p class="!m-0 !mb-1 text-caption text-on-surface font-normal">
                            {{ 'identifierColumn' | transloco }}
                        </p>
                        <p class="!m-0">{{ businessIdentifier() }}</p>
                    </div>
                </div>
            }

            <ng-content />

            @if (hasAttributes()) {
                <p>
                    <span class="font-normal text-xl"> {{ 'attribute' | transloco: { COUNT: 2 } }}</span>
                </p>
                <p class="pt-3">
                    <span class="font-medium text-lg">
                        <fa-icon
                            class="text-secondary"
                            [icon]="['fas', 'star']" />
                        {{ 'favorite' | transloco }}</span
                    >
                </p>

                <ng-content select="[attributesBookmarked]" />

                <p class="font-medium text-lg">
                    {{ 'other' | transloco }}
                </p>

                <ng-content select="[attributesOther]" />
            }
        </div>
    </div>
    <div class="footer justify-between">
        <app-button
            iconSize="sm"
            [disabled]="!canDelete()"
            [icon]="['fas', 'trash']"
            [label]="'remove' | transloco"
            [tooltip]="deleteTooltip() | transloco"
            [type]="ButtonType.ALERT_SECONDARY"
            (onClick)="deleteLayer.emit()" />

        <div>
            @if (canEditSymbology() || symbologyDisabledTooltip()) {
                <app-button
                    class="mr-2"
                    iconSize="sm"
                    [disabled]="
                        !!symbologyDisabledTooltip() ||
                        !hasPermissionsService.checkPermissions([PermissionAliasEnum.MANAGE_LAYER])
                    "
                    [icon]="['fas', 'pen']"
                    [label]="'symbology' | transloco"
                    [tooltip]="symbologyTooltip() | transloco"
                    [type]="ButtonType.SECONDARY"
                    (onClick)="layerEditService.isEditingSymbology.set(true)" />
            }
            <app-button
                iconSize="sm"
                [disabled]="!hasPermissionsService.checkPermissions([PermissionAliasEnum.MANAGE_LAYER])"
                [icon]="['fas', 'pen']"
                [label]="'edit' | transloco"
                [tooltip]="
                    !hasPermissionsService.checkPermissions([PermissionAliasEnum.MANAGE_LAYER])
                        ? ('insufficientPermissions' | transloco)
                        : undefined
                "
                [type]="ButtonType.PRIMARY"
                (onClick)="layerEditService.isEditing.set(true)" />
        </div>
    </div>
</div>
